import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EnrollService } from '../enroll.service';
import { first } from 'rxjs/operators';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { OneToNEnroll } from '../classes/one-to-n-enroll';
import { ErrorResponse } from '../classes/error';
import { Builder } from 'builder-pattern';
declare var faceapi: any;
@Component({
  selector: 'lib-capture-video',
  templateUrl: './capture-video.component.html',
  styleUrls: ['./capture-video.component.scss'],
})
export class CaptureVideoComponent implements OnInit {
  @ViewChild('video') public video!: ElementRef;
  @Input() stream!: MediaStream;
  @Input() userData: any;
  @Input() accessToken!: string;
  @Output() getResult: OneToNEnroll | ErrorResponse | any = new EventEmitter();
  tracker = null;
  stepper = new BehaviorSubject<string>('step1');
  animationShow = false;
  recordedBlobs: Array<any> = [];
  mediaRecorder: any;
  showLoading: boolean = false;
  hasPermission = false;
  alert = false;
  error = false;
  alertSuccess = false;
  messageLoading = 'Inicializando...';
  trackDisabled: boolean = false;
  faceExists = new BehaviorSubject<boolean>(false);
  message!: string;
  trackingFn: any;
  stepperObservable: any;
  options = {
    trackFace: true,
  };

  getScreenSize(event?: any): number {
    const scrWidth = window.innerWidth;
    return scrWidth;
  }
  constructor(private renderer: Renderer2, private enrollSrv: EnrollService) {}
  async ngOnInit(): Promise<void> {
    this.initStepper();
  }
  initStepper(): void {
    this.stepperObservable = this.stepper
      .asObservable()
      .subscribe(async (value) => {
        this.resizeEllipsis();
        if (value === 'step2') {
          this.step2();
        }
        if (value === 'step3') {
          this.step3();
        }
      });
  }

  async getPermissions(): Promise<void> {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then(async (stream) => {
        this.hasPermission = true;
        this.stream = stream;
        await this.initComponent();
      })
      .catch(async (e) => {
        this.showError();
        console.log(e);
      });
  }

  async initComponent(): Promise<void> {
    this.showLoading = true;
    if (this.options?.trackFace) {
      await this.setupFaceApi();
      this.initVideoStreaming();
      this.showLoading = false;
    } else {
      this.initVideoStreaming();
      this.showLoading = false;
    }
    setTimeout(() => {
      this.start();
    }, 500);
  }

  async setupFaceApi(): Promise<void> {
    const path = '../../../assets/models';
    await faceapi.nets.tinyFaceDetector.loadFromUri(path);
  }

  initVideoStreaming(): void {
    setTimeout(() => {
      this.video.nativeElement.srcObject = new MediaStream(this.stream);
      this.video.nativeElement.play();
    }, 100);
  }

  async start(): Promise<void> {
    this.stepper.next('step2');
  }

  async step2(): Promise<void> {
    this.message = 'Analisis facial';
    if (this.options?.trackFace) {
      this.faceTracking(this.video.nativeElement);
      const trackFace = this.faceExists.subscribe((value) => {
        if (value) {
          document.getElementsByTagName('canvas')[0].style.position =
            'absolute';
          this.message = 'Analisis facial';
          setTimeout(() => {
            clearInterval(this.trackingFn);
            trackFace.unsubscribe();
            document.getElementsByTagName('canvas')[0].style.display = 'none';
            this.goToStep3();
          }, 500);
        } else {
          this.message = 'No se ha detectado tu rostro';
        }
      });
    } else {
      setTimeout(() => {
        this.goToStep3();
      }, 1000);
    }
  }

  goToStep2(): void {
    this.stepper.next('step2');
  }

  goToStep3(): void {
    this.stepper.next('step3');
  }

  step3(): void {
    this.stepperObservable.unsubscribe();
    this.message = 'Grabando';
    this.startRecording();
    setTimeout(async () => {
      this.mediaRecorder.pause();
      this.mediaRecorder.stop();
      const blob = this.getBlob();
      this.showAlertSuccess();
      const video = await this.getBase64(blob);
      await this.enrroll(video);
    }, 3500);
  }

  startRecording(): void {
    let options: any = { mimeType: 'video/webm; codecs=opus,vp8' };
    if (MediaRecorder.isTypeSupported) {
      options = { mimeType: 'video/webm;codecs=vp9' };
      if (!MediaRecorder.isTypeSupported(options.mimeType)) {
        console.error(`${options.mimeType} is not Supported`);
        options = { mimeType: 'video/webm;codecs=vp8' };
        if (!MediaRecorder.isTypeSupported(options.mimeType)) {
          console.error(`${options.mimeType} is not Supported`);
          options = { mimeType: 'video/webm' };
          if (!MediaRecorder.isTypeSupported(options.mimeType)) {
            if (MediaRecorder.isTypeSupported('video/mp4')) {
              options = { mimeType: 'video/mp4', videoBitsPerSecond: 1000000 };
            } else {
              console.error(`${options.mimeType} is not Supported`);
              options = { mimeType: '' };
            }
          }
        }
      }
    } else {
      options = { mimeType: '' };
    }
    this.recordedBlobs = [];
    try {
      this.mediaRecorder = new MediaRecorder(this.stream, options);
    } catch (e) {
      this.showError();
      this.hasPermission = false;
      console.log(e);
    }
    this.mediaRecorder.ondataavailable = (event: any) => {
      if (event.data && event.data.size > 0) {
        this.recordedBlobs.push(event.data);
      }
    };
    this.mediaRecorder.start(100);
  }

  getBlob(): Blob {
    const blob = new Blob(this.recordedBlobs, { type: 'video/webm' });
    console.log(URL.createObjectURL(blob));
    return blob;
  }

  getBase64(file: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve((reader.result as string).split(',')[1]);
      reader.onerror = (error) => reject(error);
    });
  }

  faceTracking(video: any): void {
    const canvas = faceapi.createCanvasFromMedia(video);
    document.getElementById('video-container')?.append(canvas);
    document.getElementsByTagName('canvas')[0].style.transform =
      'rotateY(180deg)';
    const displaySize = {
      width: video.clientWidth,
      height: video.clientHeight,
    };
    faceapi.matchDimensions(canvas, displaySize);
    this.trackingFn = setInterval(async () => {
      const detections = await faceapi.detectSingleFace(
        video,
        new faceapi.TinyFaceDetectorOptions()
      );
      if (detections) {
        this.faceExists.next(true);
      } else {
        this.faceExists.next(false);
      }
    }, 100);
  }

  showAlert(): void {
    this.alert = true;
    setTimeout(() => {
      this.alert = false;
    }, 3250);
  }

  showError(): void {
    this.error = true;
    setTimeout(() => {
      this.error = false;
    }, 3250);
  }

  showAlertSuccess(): void {
    this.alertSuccess = true;
    setTimeout(() => {
      this.alertSuccess = false;
    }, 3250);
  }

  resizeEllipsis(): void {
    if (window.innerWidth < 768) {
      setTimeout(() => {
        const ellipsis = document.getElementById('ellipse');
        const svg = document.getElementsByTagName('svg')[0];
        const svgWidth = svg.clientWidth;
        const svgHeight = svg.clientHeight;
        const magicNumberX = 0.6956521739130435;
        const magicNumberY = 0.9352708058124174;
        if (ellipsis) {
          this.renderer.setAttribute(ellipsis, 'cx', (svgWidth / 2).toString());
          this.renderer.setAttribute(
            ellipsis,
            'cy',
            (svgHeight / 2).toString()
          );
          this.renderer.setAttribute(
            ellipsis,
            'rx',
            ((svgWidth / 2) * magicNumberX).toString()
          );
          this.renderer.setAttribute(
            ellipsis,
            'ry',
            ((svgHeight / 2) * magicNumberY).toString()
          );
          ellipsis.style.display = 'block';
        }
      }, 50);
    }
  }

  async enrroll(video: string): Promise<any> {
    this.stopStreaming();
    this.showLoading = true;
    try {
      const request = {
        video,
        user: this.userData,
      };
      const res = await this.enrollSrv
        .oneToNEnroll(request, this.accessToken)
        .pipe(first())
        .toPromise();

      this.getResult.emit(res);
    } catch (e: any) {
      console.log(e);
      if (e.error) {
        const error = Builder(ErrorResponse)
          .message(e.error.message ?? 'Something was wrong')
          .type(this.getTypeErrorByStatus(e.status))
          .response('ERROR')
          .build();
        this.getResult.emit(error);
      } else {
        this.getResult.emit(e);
      }
    }
  }

  reset(): void {
    this.hasPermission = false;
    this.showLoading = false;
    this.stepper.next('step1');
  }
  stopStreaming(): void {
    const stream = this.video.nativeElement.srcObject;
    const tracks = stream.getTracks();

    tracks.forEach((track: any) => {
      track.stop();
    });
    this.video.nativeElement.srcObject = null;
  }

  private getTypeErrorByStatus(status: number): string {
    if (status === 400) {
      return 'bad request';
    } else if (status === 401) {
      return 'unauthorized';
    } else if (status === 404) {
      return 'not found';
    } else if (status === 500) {
      return 'server error';
    } else {
      return 'unknown error';
    }
  }
}
